export default __webpack_public_path__ + "static/media/project8.5ee16da9.webp";